export default __webpack_public_path__ + "static/media/background.c13c980f.svg";